import BookButton from "../../BookButton";
import * as S from "./styles";

// Visão RESTRITA do projeto para o patrocinador que ainda não aportou (vínculo em
// Validado, Apresentado ou Não aportado).
//
// Desde 18/08/2026 ela mostra exatamente o que está no slide da apresentação —
// pedido do cliente: "ele só vê os mesmos dados que estão no ppt e tem acesso a
// baixar o book de captação". Local, Expectativa de público, Compromissos e Saldo
// a captar chegam JÁ FORMATADOS em `ppt_summary`, montado no backend pelo mesmo
// helper que monta o slide (helpers/ProjectPptFields) — replicar aqui os mapas de
// ODS e faixa etária seria abrir caminho para a tela divergir do arquivo.
//
// O cabeçalho (ProjectHeader) fica só com nome e capa: o backend não envia mais
// prazo/lei/UF/valores neste modo.
const Simplified = ({ projectData }) => {
  const summary = projectData?.ppt_summary || {};

  // Campo vazio vem `null` do backend e a linha inteira é omitida — nunca um
  // rótulo órfão.
  const rows = [
    ["Local", summary.location],
    ["Expectativa de público", summary.audience],
    ["Compromissos", summary.commitments],
    ["Saldo a captar", summary.capture_balance],
  ].filter(([, value]) => value);

  // Os três campos de prosa do slide, na mesma ordem dele.
  const texts = [
    ["Histórico", projectData?.institution_history],
    ["Resumo do projeto", projectData?.project_summary],
    ["Objetivo", projectData?.main_goal],
  ].filter(([, value]) => value);

  const book_url = summary.book_url || projectData?.caption_book_src;

  return (
    <S.Wrapper>
      {projectData?.proponent ? (
        <S.Block>
          <h2>Proponente</h2>
          <span>{projectData.proponent}</span>
        </S.Block>
      ) : null}

      {rows.length ? (
        <S.Block>
          <S.DataList>
            {rows.map(([label, value]) => (
              <li key={label}>
                <strong>{label}:</strong> {value}
              </li>
            ))}
          </S.DataList>
        </S.Block>
      ) : null}

      {/* Sem book anexado nada aparece — não um link quebrado. Mesmo rótulo e
          mesma aparência do botão do card: é o mesmo arquivo. */}
      {book_url ? (
        <S.BookAction>
          <BookButton
            variant="tertiary"
            outline
            text="PDF comercial"
            type="button"
            onClick={() =>
              window.open(book_url, "_blank", "noopener,noreferrer")
            }
          />
        </S.BookAction>
      ) : null}

      {texts.length ? (
        texts.map(([label, value]) => (
          <S.Block key={label}>
            <h2>{label}</h2>
            <p>{value}</p>
          </S.Block>
        ))
      ) : (
        <S.Block>
          <S.Empty>Este projeto ainda não possui descrição cadastrada.</S.Empty>
        </S.Block>
      )}
    </S.Wrapper>
  );
};

export default Simplified;
